/* Seasonal motion is decorative, bounded, off-screen paused and visitor controlled. */
(() => {
  if (window.CPSeasonMotion) return;
  window.CPSeasonMotion = true;
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const connection = navigator.connection;
  let paused = false;
  try { paused = sessionStorage.getItem('cp-season-motion-paused') === '1'; } catch (_) {}
  const scenes = new WeakSet();
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => entry.target.classList.toggle('is-in-view', entry.isIntersecting));
  }, { rootMargin: '40px' }) : null;
  function sync() {
    const permitted = document.body.classList.contains('cp-seasonal--motion') && document.body.classList.contains('cp-seasonal--decorated') && !preference.matches && !connection?.saveData;
    document.body.classList.toggle('cp-season-fx-running', permitted && !paused && !document.hidden);
    document.querySelectorAll('[data-cp-season-motion]').forEach(button => {
      button.hidden = !permitted;
      button.textContent = paused ? button.dataset.playLabel : button.dataset.pauseLabel;
    });
  }
  function init() {
    document.querySelectorAll('[data-cp-season-scene],.cp-season-frieze,.cp-season-story__art').forEach(scene => {
      if (scenes.has(scene)) return;
      scenes.add(scene);
      if (observer) observer.observe(scene); else scene.classList.add('is-in-view');
    });
    sync();
  }
  document.addEventListener('click', event => {
    if (!event.target.closest('[data-cp-season-motion]')) return;
    paused = !paused;
    try { sessionStorage.setItem('cp-season-motion-paused', paused ? '1' : '0'); } catch (_) {}
    sync();
  });
  document.addEventListener('visibilitychange', sync);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => {
    if (!observer) return;
    event.target.querySelectorAll('[data-cp-season-scene],.cp-season-frieze,.cp-season-story__art').forEach(scene => observer.unobserve(scene));
  });
  preference.addEventListener?.('change', sync);
  connection?.addEventListener?.('change', sync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
